<template>
  <multiselect 
    placeholder="Select Vendor"
    :options="vendors.data" 
    label="name" 
    track-by="id" 
    :value="selected" 
    @input="handleInput" @remove="handleRemove" />
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  name: 'VendorSelect',

  components: {
    Multiselect
  },

  created () {
    this.getVendors()
  },

  props: ['value', 'type'],

  computed: {
    selected () {
      return this.vendors.data.find(vendor => vendor.id === this.value)
    }
  },

  data () {
    return {
      vendors: {
        data: []
      }
    }
  },

  methods: {
    async getVendors () {
      try {
        const { data } = await this.$api.get(`account/${this.$route.params.account}/vendors`)
        this.vendors = data.vendors
        this.loading = false
      } catch (error) {
        console.error(error)
      }
    },

    handleInput (value) {
      this.$emit('input', value.id)
    },

    handleRemove () {
      this.$emit('input', null)
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>